import { connect, Dispatch } from "react-redux";
import loginActions from "ducks/loginRegister";
import marketingActions from "ducks/marketing";
import { setThinking, doneThinking } from "ducks/thinking";
import { ELOQUA_LEAD_SOURCE_VALUES } from "common/constants/Constants";
// eslint-disable-next-line import/named
import { RouteComponentProps } from "react-router";
import { SignupProps } from "components/v4/register/Register";

interface LocalState {
    loginRegister?: {
        email?: string;
        errors: Record<string, { type: string; message: string } | undefined>;
    };
    country?: string;
    thinking?: boolean;
}

type StateToProps = Pick<SignupProps, "thinking" | "errors" | "email" | "country" | "closeable" | "title" | "buttonCopy" | "successCopy">;
type DispatchToProps = Pick<SignupProps, "onSignup">;

interface QueryParams {
    redirectTo: string;
    closeable?: string;
    title?: string;
    buttonCopy?: string;
    successCopy?: string;
}

type OwnProps = RouteComponentProps<undefined, undefined, undefined, QueryParams>;

export function createMapStateToProps() {
    return (state: LocalState, ownProps: OwnProps): StateToProps => {
        const { loginRegister = { errors: {} }, country, thinking } = state;
        const { location: { query: { closeable, title, buttonCopy, successCopy } } } = ownProps;

        return {
            thinking,
            errors: loginRegister.errors,
            email: loginRegister.email,
            country,
            closeable: closeable !== "false",
            title: title && decodeURIComponent(title),
            buttonCopy: buttonCopy && decodeURIComponent(buttonCopy),
            successCopy: successCopy && decodeURIComponent(successCopy)
        };
    };
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function mapDispatchToProps(dispatch: Dispatch<any>, ownProps: OwnProps): DispatchToProps {
    return {
        onSignup(email: string, optIn: boolean, captcha?: string): Promise<void> {
            dispatch(loginActions.clearError("register"));
            dispatch(marketingActions.setIsOptedIn(optIn));
            dispatch(setThinking());

            return dispatch(marketingActions.sendEmailToEloquaAndCpref(
                email,
                ownProps.location.query.closeable === "false"
                    ? ELOQUA_LEAD_SOURCE_VALUES.REGISTRATION_REG_WALL
                    : ELOQUA_LEAD_SOURCE_VALUES.REGISTRATION_REGULAR,
                true
            ))
                .catch(() => { /* do nothing */ })
                .then(() => {
                    return dispatch(loginActions.register(email, captcha, ownProps.location.query.redirectTo));
                })
                .then((): void => {
                    dispatch(loginActions.emailChange(email));
                    dispatch(doneThinking());
                })
                .catch((): void => {
                    dispatch(doneThinking());
                });
        }
    };
}

function createRegistrationSignupContainer(
    component: React.ComponentType<StateToProps & DispatchToProps>
): React.ComponentClass<Pick<StateToProps & DispatchToProps, never> & OwnProps> {
    return connect(
        createMapStateToProps(),
        mapDispatchToProps
    )(component);
}

export default createRegistrationSignupContainer;
